import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=1cba2fc0&scoped=true"
import script from "./RefundPolicy.vue?vue&type=script&lang=js"
export * from "./RefundPolicy.vue?vue&type=script&lang=js"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=1cba2fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba2fc0",
  null
  
)

export default component.exports